export default __webpack_public_path__ + "static/media/c001-general2024-5.1e1b6183.png";